import { create } from 'zustand';

const useAudioStore = create((set, get) => ({
  currentlyPlaying: null,
  audioRefs: new Map(),

  playAudio: (id, audioUrl) => {
    const { currentlyPlaying, audioRefs } = get();

    // Pause currently playing audio
    if (currentlyPlaying && currentlyPlaying !== id) {
      const currentAudio = audioRefs.get(currentlyPlaying);
      if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
      }
    }

    // Play new audio
    const audio = new Audio(audioUrl);
    audioRefs.set(id, audio);

    audio
      .play()
      .then(() => {
        set({ currentlyPlaying: id });
      })
      .catch((error) => {
        console.error('Error playing audio:', error);
      });

    // Reset state when audio ends
    audio.onended = () => {
      set({ currentlyPlaying: null });
      audioRefs.delete(id);
    };
  },

  pauseAudio: (id) => {
    const { currentlyPlaying, audioRefs } = get();
    const audio = audioRefs.get(id);

    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }

    if (currentlyPlaying === id) {
      set({ currentlyPlaying: null });
    }
  },

  pauseAll: () => {
    const { audioRefs } = get();

    audioRefs.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });

    set({ currentlyPlaying: null });
    audioRefs.clear();
  },

  isPlaying: (id) => {
    return get().currentlyPlaying === id;
  },
}));

export default useAudioStore;
